import React from "react";

export const WeatherDataConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  routes: [
    {
      path: "/activity-management/projects",
      component: React.lazy(() => import("./weatherData"))
    }
  ]
};
